import { CapacitorSQLite, SQLiteConnection } from '@capacitor-community/sqlite';
import { Capacitor } from '@capacitor/core';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { setupIonicReact } from '@ionic/react';
import { applyPolyfills, defineCustomElements as jeepSqlite } from 'jeep-sqlite/loader';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as StoreProvider } from 'react-redux';

import App from './App';
import store from './store';
import { injectStore as injectAxiosDmsStore } from './api/dms/axiosDmsInterceptors';
import { injectStore as injectLogStore } from './common/log';
import { injectStore as injectUtilStore } from './common/util';
import DataSyncProvider from './providers/DataSyncProvider';
import LocationProvider from './providers/LocationProvider';
import ToastProvider from './providers/ToastProvider';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import SqliteProvider from './sqlite/sqlConnectionProvider';
import { CustomStyle } from './theme/Custom.styles';
import { GlobalStyle } from './theme/Global.style';
import './theme/Ionic.styles';

applyPolyfills().then(() => {
  jeepSqlite(window);
});

injectAxiosDmsStore(store);
injectUtilStore(store);
injectLogStore(store);

setupIonicReact();

const configureDb = async (databaseName: string) => {
  //logTransaction(LogType.Internal, `configuring sqlite db ${databaseName}`);
  const platform = Capacitor.getPlatform();
  const sqlite: SQLiteConnection = new SQLiteConnection(CapacitorSQLite);

  if (platform === 'web') {
    const jeepEl = document.createElement('jeep-sqlite');
    document.body.appendChild(jeepEl);
    await customElements.whenDefined('jeep-sqlite');
    await sqlite.initWebStore();
  }
};

window.addEventListener('DOMContentLoaded', async () => {
  try {
    // Init sqlite db
    await configureDb(process.env.REACT_APP_DBNAME!);

    const container = document.getElementById('root');
    const root = createRoot(container!);

    root.render(
      <React.StrictMode>
        <ToastProvider>
          <StoreProvider store={store}>
            <SqliteProvider databaseName={process.env.REACT_APP_DBNAME!}>
              <LocationProvider>
                {/* <NotificationProvider> */}
                <DataSyncProvider>
                  <GlobalStyle />
                  <CustomStyle />
                  <App />
                </DataSyncProvider>
                {/* </NotificationProvider> */}
              </LocationProvider>
            </SqliteProvider>
          </StoreProvider>
        </ToastProvider>
      </React.StrictMode>,
    );

    defineCustomElements(window);

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://cra.link/PWA
    serviceWorkerRegistration.unregister();

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
  } catch (ex) {
    console.log(`Error: ${ex}`);
    throw new Error(`Error: ${ex}`);
  }
});
